module.exports = __webpack_public_path__ + "img/ATTACHMENT.2bb461bc.svg";